{
  "signIn": {
    "title": "Sign in",
    "subtitle": "Continue to your projects.",
    "email": "Email address",
    "password": "Password",
    "remember": "Keep me signed in",
    "rememberHint": "Stays signed in for 30 days on this device.",
    "submit": "Sign in",
    "submitting": "Signing in",
    "forgot": "Forgot your password?",
    "noAccount": "Do not have an account?",
    "createAccount": "Create one",
    "google": "Continue with Google",
    "or": "or"
  },
  "signUp": {
    "title": "Create an account",
    "subtitle": "Start a trial organisation, or accept an invitation.",
    "name": "Full name",
    "email": "Email address",
    "password": "Password",
    "passwordHint": "At least 12 characters. Avoid a password you have used elsewhere.",
    "submit": "Create account",
    "submitting": "Creating your account",
    "haveAccount": "Already have an account?",
    "signIn": "Sign in"
  },
  "forgotPassword": {
    "title": "Reset your password",
    "subtitle": "We will email you a link to choose a new one.",
    "backToSignIn": "Back to sign in",
    "email": "Email address",
    "submit": "Email me a link",
    "submitting": "Sending",
    "sent": {
      "title": "Check your email",
      "description": "If an account uses that address, a link to choose a new password is on its way. It expires in 60 minutes and can be used once."
    }
  },
  "resetPassword": {
    "title": "Choose a new password",
    "subtitle": "The link you followed lets you set a new password once.",
    "password": "New password",
    "submit": "Set new password",
    "submitting": "Saving",
    "missingToken": {
      "title": "This link is incomplete",
      "description": "Open the link from the email again, or ask for a new one."
    },
    "done": {
      "title": "Password changed",
      "description": "Sign in with your new password."
    }
  },
  "verifyEmail": {
    "title": "Verify your email",
    "subtitle": "Confirm your address before running an analysis.",
    "verified": {
      "title": "Email confirmed",
      "description": "Your address is confirmed. You can run analyses now."
    },
    "pending": {
      "title": "Confirm your email",
      "description": "We sent a link to your address. Follow it to finish setting up your account."
    },
    "invalid": {
      "title": "This link no longer works",
      "description": "It expired, or the address on the account changed after it was sent. Send yourself a new one."
    },
    "resend": "Send a new link",
    "resending": "Sending",
    "resent": "A new link is on its way.",
    "alreadyVerified": "That address is already confirmed.",
    "continue": "Go to your projects"
  },
  "validation": {
    "emailRequired": "Enter your email address",
    "emailInvalid": "Enter a valid email address",
    "passwordRequired": "Enter your password",
    "nameRequired": "Enter your name",
    "passwordTooShort": "Use at least 12 characters"
  }
}
